export const AUTHORIZATION = 'Basic YXBwOmFwcA=='; //'Basic d2ViQXBwOndlYkFwcA=='